import React from "react";
import RootSigningStatusBadge, {
    ContractSigningStatusPlus,
} from "../../components/SigningStatusBadge";
import { View } from "react-native";
import VStack from "../../ui_atoms/VStack";
import { ContractSignatureStatus, ProfileType } from "../../__generated__/graphql";
import { getAvatarUrl, getAvatarUrl2 } from "../factories";
import type { Meta, StoryObj } from "@storybook/react";

const StoryComponent = ({
    status,
    profileType,
}: {
    status: ContractSigningStatusPlus;
    profileType: ProfileType;
}) => {
    return (
        <VStack gap={0.5} alignment="stretch" style={{ width: "100%" }}>
            <RootSigningStatusBadge
                status={status}
                clientAvatarUrl={getAvatarUrl()}
                workerAvatarUrl={getAvatarUrl2()}
                selfProfileType={profileType}
            />
        </VStack>
    );
};

const meta = {
    title: "Components/Signing badge",
    component: StoryComponent,
    argTypes: {
        status: {
            options: Object.values(ContractSignatureStatus),
            control: { type: "select" },
        },
        profileType: {
            options: Object.values(ProfileType),
            control: { type: "radio" },
        },
    },
    args: {
        status: ContractSignatureStatus.NeedSelfSign,
        profileType: ProfileType.Client,
    },
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const NeedSelfSign: Story = {
    args: {
        status: ContractSignatureStatus.NeedSelfSign,
        profileType: ProfileType.Client,
    },
};
